"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoginToChatIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const LoginToChat_svg_1 = __importDefault(require("./LoginToChat.svg"));
/**
 *
 */
function LoginToChatIcon() {
    return (0, jsx_runtime_1.jsx)(LoginToChat_svg_1.default, {});
}
exports.LoginToChatIcon = LoginToChatIcon;
//# sourceMappingURL=index.js.map